// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask--1CHzd","popUp":"popUp--2s4N9","popUp_close":"popUp_close--2557j","popUp_title":"popUp_title--2xISP"};